import ApiService from "../services/api";
import { NotificationUser, NotificationUserFormData } from "../models/notificationUser";

export interface NotificationUsersPaginationData {
  users: NotificationUser[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
}

export const fetchNotificationUsers = async (params: { page?: number, limit?: number }): Promise<NotificationUsersPaginationData> => {
  const apiService = new ApiService();
  
  try {
    const response = await apiService.get<any>(`/budgets/notification-users`, { params });
    if (response.status !== 200) throw new Error("Error fetching notification users");
    
    const users = response.data.users.map((user: any) => ({
      id: user.id?.toString(),
      userId: user.userId,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
    }));

    return {
      users,
      totalElements: response.data.totalElements || 0,
      totalPages: response.data.totalPages || 0,
      currentPage: response.data.currentPage || 1,
      pageSize: response.data.pageSize || 20,
    };
  } catch (error) {
    console.error('Error fetching notification users:', error);
    return {
      users: [],
      totalElements: 0,
      totalPages: 0,
      currentPage: 1,
      pageSize: 20,
    };
  }
};

export const createNotificationUser = async (data: NotificationUserFormData): Promise<boolean> => {
  const apiService = new ApiService();
  
  try {
    const { id, ...payload } = data as any;
    const response = await apiService.post<any>('/budgets/notification-users', payload);
    return response.status >= 200 && response.status < 300;
  } catch (error) {
    console.error('Error creating notification user:', error);
    return false;
  }
};

export const deleteNotificationUser = async (id: string): Promise<boolean> => {
  const apiService = new ApiService();
  
  try {
    const response = await apiService.delete(`/budgets/notification-users/${id}`);
    return response.status >= 200 && response.status < 300;
  } catch (error) {
    console.error('Error deleting notification user:', error);
    return false;
  }
};

